import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M8 15c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm0-2c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
        />
        <path
          className="icon-color"
          d="M9 7h2c.552 0 1 .448 1 1s-.448 1-1 1H9v2c0 .552-.448 1-1 1s-1-.448-1-1V9H5c-.552 0-1-.448-1-1s.448-1 1-1h2V5c0-.552.448-1 1-1s1 .448 1 1v2z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
        />
        <path
          className="icon-color"
          d="M13 11h3c.552 0 1 .448 1 1s-.448 1-1 1h-3v3c0 .552-.448 1-1 1s-1-.448-1-1v-3H8c-.552 0-1-.448-1-1s.448-1 1-1h3V8c0-.552.448-1 1-1s1 .448 1 1v3z"
        />
      </g>
    </svg>
  ),
};
